import { SelectControl, ToggleControl } from "@wordpress/components";
import { Dashicon } from "@wordpress/components";
import { Modal } from "@wordpress/components";
import { Button } from "@wordpress/components";
import { TextareaControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import BColor from "../Components/BColor";
const { Fragment, useEffect, useRef, useState } = wp.element;
const { Panel, PanelBody, PanelRow, FormToggle, TextControl, __experimentalNumberControl: NumberControl, __experimentalUnitControl: UnitControl } = wp.components;
const { InspectorControls } = wp.blockEditor;
const { select } = wp.data;

// import BRangeControl from "../Components/BRangeControl";
import BMediaUpload from "../Components/BMediaUpload";
import BSpacer from "../Components/BSpacer";
import GoogleDrivePicker from "./GoogleDrivePicker";
import PresetOptions from "./PresetOptions";
import { ajaxCall, presetDelete } from "./utils";
import BControlPro from "../Components/BControlPro";

const Settings = (props) => {
  const { getCurrentPostId } = select("core/editor");
  const chooserContainer = useRef(null);
  const gDriveContainer = useRef(null);
  const [confirm, setConfirm] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPremium, setIsPremium] = useState(pdfp?.pipe);

  const { attributes, preset, setPreset, setAttributes, setModalOpen } = props;
  const {
    uniqueId,
    file,
    title,
    titleFontSize,
    height,
    width,
    showName,
    print,
    onlyPDF,
    defaultBrowser,
    adobeEmbedder,
    downloadButton,
    downloadButtonText,
    fullscreenButton,
    fullscreenButtonText,
    newWindow,
  } = attributes;

  const {
    protect,
    thumbMenu,
    sidebarOpen,
    initialPage,
    zoomLevel,
    alert,
    lastVersion,
    hrScroll,
    additional,
    adobeOptions,
    popupBtnStyle,
    popupBtnText,
    statePresets = [],
  } = attributes;

  const exampleFile = "http://localhost/freemius/wp-content/uploads/2022/02/temp.pdf";

  useEffect(() => {
    if (typeof Dropbox !== "undefined") {
      options = {
        success: function (file) {
          setAttributes({ file: file?.[0]?.link });
        },
        cancel: function () {},
        linkType: "preview", // or "direct", "preview"
        multiselect: false, // or true
        folderselect: false, // or true
      };

      var button = Dropbox.createChooseButton(options);
      setTimeout(() => {
        if (chooserContainer.current && !chooserContainer.current?.hasChildNodes()) {
          chooserContainer.current.appendChild(button);
        }
      }, 1000);
    }

    const fetch = async () => {
      const { data } = await ajaxCall("GET", { model: "Presets", method: "all" });
      setAttributes({ statePresets: data });
    };
    fetch();
  }, []);

  const handleDeletePreset = async (id) => {
    setLoading(true);
    const { data } = await presetDelete(id);
    if (data) {
      setAttributes({ statePresets: statePresets.filter((preset) => preset.id !== id) });
    }
    setConfirmModalOpen(false);
    setLoading(false);
  };

  const postType = select("core/editor").getCurrentPostType();
  const postId = getCurrentPostId();

  return (
    <>
      <InspectorControls style={{ marginBottom: "40px" }}>
        <Fragment>
          <Panel>
            {postType === "pdfposter" && (
              <PanelBody>
                <PanelRow>
                  <div className="pdfp_front_shortcode">
                    <input value={`[pdf id=${postId}]`} />
                    <span className="htooltip">{__("Copy To Clipboard", "pdfp")}</span>
                  </div>
                </PanelRow>
              </PanelBody>
            )}

            <PanelBody>
              {isPremium && (
                <>
                  <PanelRow>
                    <div id="picker_container" ref={chooserContainer}></div>
                  </PanelRow>
                  <GoogleDrivePicker setAttributes={setAttributes} clientId={fpdfAdmin?.gClientId} appId={fpdfAdmin?.gAppId} developerKey={fpdfAdmin?.gDeveloperKey} />
                </>
              )}

              <PanelRow>
                <label className="label">{__("Upload PDF", "pdfp")}</label>
              </PanelRow>

              <BMediaUpload type={["application/pdf"]} onSelect={(file) => setAttributes({ file })} value={file} placeholder="Audio URL" />

              {isPremium && <TextControl disabled={!isPremium} label={__("Title", "pdfp")} value={title} onChange={(title) => setAttributes({ title })} />}

              {!isPremium && (
                <>
                  {<ToggleControl label={__("Allow print", "pdfp")} id="print" checked={print} onChange={() => setAttributes({ print: !print })} />}

                  <ToggleControl label={__("Show title on top", "pdfp")} id="showName" checked={showName} onChange={() => setAttributes({ showName: !showName })} />
                  <TextControl
                    label={__("Fullscreen Button Text", "pdfp")}
                    value={fullscreenButtonText}
                    onChange={(fullscreenButtonText) => setAttributes({ fullscreenButtonText })}
                  />
                </>
              )}
            </PanelBody>

            {isPremium && (
              <PanelBody title={__("Presets", "pdfp")}>
                <div className="pdfp-presets">
                  {statePresets.map((item) => (
                    <>
                      <div className={`pdfp-preset-item`}>
                        <div
                          className="box"
                          onClick={() => {
                            setAttributes({ ...item.preset });
                          }}
                        >
                          <span>{item.name?.[0]?.toUpperCase()}</span>
                        </div>
                        <div className="actions">
                          <Dashicon
                            icon="edit"
                            title={__("Edit", "pdfp")}
                            onClick={() => {
                              setPreset(item);
                              setModalOpen(true);
                              // setAttributes({ ...item.preset })
                            }}
                          />
                          <Dashicon
                            icon="trash"
                            title={__("Delete", "pdfp")}
                            onClick={(e) => {
                              e.preventDefault();
                              setConfirmModalOpen(item.id);
                            }}
                          />
                        </div>
                        <p>{item?.name || __("Unknown Name", "pdfp")}</p>
                      </div>
                    </>
                  ))}
                </div>
                <Button
                  variant="primary"
                  onClick={() => {
                    setModalOpen(true);
                    const { uniqueId, statePresets, ...preset } = attributes;
                    setPreset({ preset });
                  }}
                >
                  {__("Add New Preset", "pdfp")}
                </Button>
              </PanelBody>
            )}

            <PanelBody title={__("Settings", "pdfp")} initialOpen={false}>
              <BControlPro
                isPremium={isPremium}
                Component={ToggleControl}
                label={__("use adobe PDF embedder", "pdfp")}
                id="adobeEmbedder"
                checked={adobeEmbedder}
                onChange={() => setAttributes({ adobeEmbedder: !adobeEmbedder })}
              />

              {adobeEmbedder && isPremium && (
                <>
                  <PanelRow>
                    <label htmlFor="embedMode" className="label">
                      {__("Embed Mode", "pdfp")}
                    </label>
                    <SelectControl
                      options={[
                        { label: "Sized Container", value: "SIZED_CONTAINER" },
                        { label: "Full Window", value: "FULL_WINDOW" },
                        { label: "In-Line", value: "IN_LINE" },
                        { label: "Lightbox", value: "LIGHT_BOX" },
                      ]}
                      value={adobeOptions.embedMode}
                      onChange={(embedMode) => setAttributes({ adobeOptions: { ...adobeOptions, embedMode } })}
                    />
                  </PanelRow>

                  {adobeOptions?.embedMode === "LIGHT_BOX" && (
                    <PanelRow>
                      <TextControl label={__("Button Text", "pdfp")} value={popupBtnText} onChange={(popupBtnText) => setAttributes({ popupBtnText })} />
                    </PanelRow>
                  )}

                  {["SIZED_CONTAINER", "IN_LINE", "LIGHT_BOX", "FULL_WINDOW"].includes(adobeOptions.embedMode) && (
                    <PanelRow>
                      <label htmlFor="showPrintPDF" className="label">
                        {__("Show Print Button", "pdfp")}
                      </label>
                      <FormToggle
                        id="showPrintPDF"
                        checked={adobeOptions?.showPrintPDF}
                        onChange={() => setAttributes({ adobeOptions: { ...adobeOptions, showPrintPDF: !adobeOptions?.showPrintPDF } })}
                      />
                    </PanelRow>
                  )}
                  {["SIZED_CONTAINER", "IN_LINE", "LIGHT_BOX", "FULL_WINDOW"].includes(adobeOptions.embedMode) && (
                    <PanelRow>
                      <label htmlFor="showDownloadPDF" className="label">
                        {__("Show Download Button", "pdfp")}
                      </label>
                      <FormToggle
                        id="showDownloadPDF"
                        checked={adobeOptions?.showDownloadPDF}
                        onChange={() => setAttributes({ adobeOptions: { ...adobeOptions, showDownloadPDF: !adobeOptions?.showDownloadPDF } })}
                      />
                    </PanelRow>
                  )}
                  {["SIZED_CONTAINER"].includes(adobeOptions.embedMode) && (
                    <PanelRow>
                      <label htmlFor="showFullScreen" className="label">
                        {__("Show Fullscreen Button", "pdfp")}
                      </label>
                      <FormToggle
                        id="showFullScreen"
                        checked={adobeOptions?.showFullScreen}
                        onChange={() => setAttributes({ adobeOptions: { ...adobeOptions, showFullScreen: !adobeOptions?.showFullScreen } })}
                      />
                    </PanelRow>
                  )}
                  {["FULL_WINDOW"].includes(adobeOptions.embedMode) && (
                    <>
                      <PanelRow>
                        <label htmlFor="showAnnotationTools" className="label">
                          {__("Show Annotation Tools", "pdfp")}
                        </label>
                        <FormToggle
                          id="showAnnotationTools"
                          checked={adobeOptions?.showAnnotationTools}
                          onChange={() => setAttributes({ adobeOptions: { ...adobeOptions, showAnnotationTools: !adobeOptions?.showAnnotationTools } })}
                        />
                      </PanelRow>
                      {/* <PanelRow>
                      <label htmlFor="defaultViewMode" className="label">
                        {__("View Mode", "pdfp")}
                      </label>
                      <SelectControl
                        options={[
                          { label: "Fit Page", value: "FIT_PAGE" },
                          { label: "Fit Width", value: "FIT_WIDTH" },
                          { label: "Two Column", value: "TWO_COLUMN" },
                          { label: "Two Column Fit Page", value: "TWO_COLUMN_FIT_PAGE" },
                        ]}
                        value={adobeOptions.defaultViewMode}
                        onChange={(defaultViewMode) => setAttributes({ adobeOptions: { ...adobeOptions, defaultViewMode } })}
                      />
                    </PanelRow> */}
                    </>
                  )}
                </>
              )}

              {!adobeEmbedder && (
                <>
                  <BControlPro
                    isPremium={isPremium}
                    Component={ToggleControl}
                    label={__("Protect my content", "pdfp")}
                    id="protect"
                    checked={protect}
                    onChange={() => setAttributes({ protect: !protect })}
                  />

                  {protect && (
                    <BControlPro
                      isPremium={isPremium}
                      Component={ToggleControl}
                      label={__("Enable Alert", "pdfp")}
                      id="alert"
                      checked={alert}
                      onChange={() => setAttributes({ alert: !alert })}
                    />
                  )}

                  {!protect && isPremium && <ToggleControl label={__("Allow print", "pdfp")} id="print" checked={print} onChange={() => setAttributes({ print: !print })} />}

                  {isPremium && <ToggleControl label={__("Show title on top", "pdfp")} id="showName" checked={showName} onChange={() => setAttributes({ showName: !showName })} />}

                  <BControlPro
                    isPremium={isPremium}
                    Component={ToggleControl}
                    label={__("Raw PDF", "pdfp")}
                    id="onlyPDF"
                    checked={onlyPDF}
                    onChange={() => setAttributes({ onlyPDF: !onlyPDF })}
                  />

                  {!protect && (
                    <Fragment>
                      <BControlPro
                        isPremium={isPremium}
                        Component={ToggleControl}
                        label={__("Use browser pdf viewer", "pdfp")}
                        id="defaultBrowser"
                        checked={defaultBrowser}
                        onChange={() => setAttributes({ defaultBrowser: !defaultBrowser })}
                      />

                      <BControlPro
                        isPremium={isPremium}
                        Component={ToggleControl}
                        label={__("Show download button", "pdfp")}
                        id="downloadButton"
                        checked={downloadButton}
                        onChange={() => setAttributes({ downloadButton: !downloadButton })}
                      />

                      {downloadButton && (
                        <BControlPro
                          isPremium={isPremium}
                          Component={TextControl}
                          label="Download Button Text"
                          value={downloadButtonText}
                          onChange={(downloadButtonText) => setAttributes({ downloadButtonText })}
                        />
                      )}
                    </Fragment>
                  )}
                  {!protect && (
                    <Fragment>
                      <BControlPro
                        isPremium={isPremium}
                        Component={ToggleControl}
                        label={__("Show fullscreen button", "pdfp")}
                        id="fullscreenButton"
                        checked={fullscreenButton}
                        onChange={() => setAttributes({ fullscreenButton: !fullscreenButton })}
                      />

                      {fullscreenButton && (
                        <Fragment>
                          {isPremium && (
                            <TextControl
                              label={__("Fullscreen Button Text", "pdfp")}
                              value={fullscreenButtonText}
                              onChange={(fullscreenButtonText) => setAttributes({ fullscreenButtonText })}
                            />
                          )}
                          <BControlPro
                            isPremium={isPremium}
                            Component={ToggleControl}
                            label={__("Open fullscreen in new window", "pdfp")}
                            id="newWindow"
                            checked={newWindow}
                            onChange={() => setAttributes({ newWindow: !newWindow })}
                          />
                        </Fragment>
                      )}
                    </Fragment>
                  )}

                  {!onlyPDF && (
                    <>
                      <BControlPro
                        isPremium={isPremium}
                        Component={ToggleControl}
                        label={__("Enable thumbnails toggle menu", "pdfp")}
                        id="thumbMenu"
                        checked={thumbMenu}
                        onChange={() => setAttributes({ thumbMenu: !thumbMenu })}
                      />

                      {thumbMenu && (
                        <BControlPro
                          isPremium={isPremium}
                          Component={ToggleControl}
                          label={__("Show Thumb by Default", "pdfp")}
                          id="sidebarOpen"
                          checked={sidebarOpen}
                          onChange={() => setAttributes({ sidebarOpen: !sidebarOpen })}
                        />
                      )}
                    </>
                  )}

                  <BControlPro
                    isPremium={isPremium}
                    Component={ToggleControl}
                    label={__("Load the last version of the PDF", "pdfp")}
                    id="lastVersion"
                    checked={lastVersion}
                    onChange={() => setAttributes({ lastVersion: !lastVersion })}
                  />

                  <BControlPro
                    isPremium={isPremium}
                    Component={ToggleControl}
                    label={__("Horizontal Scrollbar", "pdfp")}
                    id="hrScroll"
                    checked={hrScroll}
                    onChange={() => setAttributes({ hrScroll: !hrScroll })}
                  />

                  <BControlPro
                    label={__("Initail page", "pdfp")}
                    isPremium={isPremium}
                    Component={NumberControl}
                    isShiftStepEnabled={true}
                    onChange={(initialPage) => setAttributes({ initialPage })}
                    shiftStep={1}
                    value={initialPage}
                  />

                  <BControlPro
                    label={__("Zoom Level (%)", "pdfp")}
                    isPremium={isPremium}
                    Component={NumberControl}
                    help={__("leave empty to set auto", "pdfp")}
                    isShiftStepEnabled={true}
                    onChange={(zoomLevel) => setAttributes({ zoomLevel: parseInt(zoomLevel) })}
                    min={25}
                    max={300}
                    shiftStep={1}
                    value={zoomLevel}
                  />
                </>
              )}
            </PanelBody>
            <PanelBody title={__("Style", "pdfp")} initialOpen={false}>
              <PanelRow>
                <label htmlFor="Height" className="label">
                  {__("Height", "pdfp")}
                </label>
                <UnitControl
                  onChange={(height) => setAttributes({ height })}
                  value={height}
                  units={[
                    { value: "px", label: "px", default: 500 },
                    { value: "%", label: "%", default: 100 },
                    { value: "vh", label: "vh", default: 100 },
                  ]}
                  isResetValueOnUnitChange={true}
                />
              </PanelRow>
              <PanelRow>
                <label htmlFor="width" className="label">
                  {__("Width", "pdfp")}
                </label>
                <UnitControl
                  onChange={(width) => setAttributes({ width })}
                  value={width}
                  units={[
                    { value: "px", label: "px", default: 500 },
                    { value: "%", label: "%", default: 100 },
                    { value: "vw", label: "vw", default: 100 },
                  ]}
                  isResetValueOnUnitChange={true}
                />
              </PanelRow>
              {/* <PanelRow>
                <label htmlFor="titleFontSize" className="label">
                  {__("Title Font Size", "pdfp")}
                </label> */}
              {/* </PanelRow> */}
              {isPremium && (
                <UnitControl
                  label={__("Title Font Size", "pdfp")}
                  onChange={(titleFontSize) => setAttributes({ titleFontSize })}
                  value={titleFontSize}
                  units={[
                    { value: "px", label: "px", default: 16 },
                    { value: "em", label: "em", default: 1 },
                    { value: "rem", label: "rem", default: 1 },
                  ]}
                  isResetValueOnUnitChange={true}
                />
              )}
            </PanelBody>
            {adobeOptions.embedMode === "LIGHT_BOX" && adobeEmbedder && isPremium && (
              <PanelBody title={__("Adobe Lightbox Button Style", "pdfp")}>
                <PanelRow>
                  <label>{__("Background", "bpm")}</label>
                  <BColor value={popupBtnStyle?.background} onChange={(background) => setAttributes({ popupBtnStyle: { ...popupBtnStyle, background } })} />
                </PanelRow>
                <PanelRow>
                  <label>{__("Text Color", "bpm")}</label>
                  <BColor value={popupBtnStyle?.color} onChange={(color) => setAttributes({ popupBtnStyle: { ...popupBtnStyle, color } })} />
                </PanelRow>
                <BSpacer
                  title={__("Padding", "pdfp")}
                  value={popupBtnStyle?.padding || {}}
                  onChange={(padding) => setAttributes({ popupBtnStyle: { ...popupBtnStyle, padding } })}
                />
              </PanelBody>
            )}
            <PanelBody title={__("Additional", "pdfp")} initialOpen={false}>
              {/* <PanelRow>
              <label>{__("ID", "pdfp")}</label>
              <TextControl value={additional.ID} onChange={(ID) => setAttributes({ additional: { ...additional, ID } })} />
            </PanelRow> */}

              <BControlPro
                isPremium={isPremium}
                Component={TextControl}
                label={__("Class", "pdfp")}
                value={additional.Class}
                onChange={(Class) => setAttributes({ additional: { ...additional, Class } })}
              />
              <BControlPro
                isPremium={isPremium}
                Component={TextareaControl}
                label={__("CSS", "pdfp")}
                value={additional.CSS}
                onChange={(CSS) => setAttributes({ additional: { ...additional, CSS } })}
              />
            </PanelBody>
          </Panel>
        </Fragment>
      </InspectorControls>
      {confirmModalOpen && (
        <Modal title={__("Do you want to delete?", "pdfp")} onRequestClose={() => setConfirmModalOpen(false)}>
          <div className="confirmPresetDelete">
            {loading && <span className="pdfp_loader"></span>}
            {/* <Button variant="primary" onClick={() => setConfirmModalOpen(false)}>{__('No', 'pdfp')}</Button> */}
            <Button
              disabled={loading}
              variant="primary"
              onClick={() => {
                setConfirm(true);
                handleDeletePreset(confirmModalOpen);
              }}
            >
              {__("Yes", "pdfp")}
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Settings;
